function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime/helpers/interopRequireDefault.js
 ** module id = 32
 ** module chunks = 0
 **/